module.exports = __webpack_public_path__ + "img/45-e54b36.png";